/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pain.reducer';

export const Pain = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const painList = useAppSelector(state => state.pain.entities);
  const loading = useAppSelector(state => state.pain.loading);
  const totalItems = useAppSelector(state => state.pain.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pain-heading" data-cy="PainHeading">
        <Translate contentKey="tinyMedicRestApp.pain.home.title">Pains</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pain.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/pain/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pain.home.createLabel">Create new Pain</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pain.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {painList && painList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pain.id">Id</Translate> <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('cramps')}>
                  <Translate contentKey="tinyMedicRestApp.pain.cramps">Cramps</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cramps')} />
                </th>
                <th className="hand" onClick={sort('crampLevel')}>
                  <Translate contentKey="tinyMedicRestApp.pain.crampLevel">Cramp Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('crampLevel')} />
                </th>
                <th className="hand" onClick={sort('ovulationPain')}>
                  <Translate contentKey="tinyMedicRestApp.pain.ovulationPain">Ovulation Pain</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ovulationPain')} />
                </th>
                <th className="hand" onClick={sort('opLevel')}>
                  <Translate contentKey="tinyMedicRestApp.pain.opLevel">Op Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('opLevel')} />
                </th>
                <th className="hand" onClick={sort('headache')}>
                  <Translate contentKey="tinyMedicRestApp.pain.headache">Headache</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('headache')} />
                </th>
                <th className="hand" onClick={sort('headacheLevel')}>
                  <Translate contentKey="tinyMedicRestApp.pain.headacheLevel">Headache Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('headacheLevel')} />
                </th>
                <th className="hand" onClick={sort('backache')}>
                  <Translate contentKey="tinyMedicRestApp.pain.backache">Backache</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('backache')} />
                </th>
                <th className="hand" onClick={sort('backacheLevel')}>
                  <Translate contentKey="tinyMedicRestApp.pain.backacheLevel">Backache Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('backacheLevel')} />
                </th>
                <th className="hand" onClick={sort('nausea')}>
                  <Translate contentKey="tinyMedicRestApp.pain.nausea">Nausea</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('nausea')} />
                </th>
                <th className="hand" onClick={sort('nauseaLevel')}>
                  <Translate contentKey="tinyMedicRestApp.pain.nauseaLevel">Nausea Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('nauseaLevel')} />
                </th>
                <th className="hand" onClick={sort('tenderBreasts')}>
                  <Translate contentKey="tinyMedicRestApp.pain.tenderBreasts">Tender Breasts</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tenderBreasts')} />
                </th>
                <th className="hand" onClick={sort('migraine')}>
                  <Translate contentKey="tinyMedicRestApp.pain.migraine">Migraine</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('migraine')} />
                </th>
                <th className="hand" onClick={sort('migraneLevel')}>
                  <Translate contentKey="tinyMedicRestApp.pain.migraneLevel">Migrane Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('migraneLevel')} />
                </th>
                <th className="hand" onClick={sort('other')}>
                  <Translate contentKey="tinyMedicRestApp.pain.other">Other</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('other')} />
                </th>
                <th className="hand" onClick={sort('comments')}>
                  <Translate contentKey="tinyMedicRestApp.pain.comments">Comments</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('comments')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pain.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.pain.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pain.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.pain.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pain.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.pain.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pain.cycleDay">Cycle Day</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {painList.map((pain, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pain/${pain.id}`} color="link" size="sm">
                      {pain.id}
                    </Button>
                  </td>
                  <td>{pain.cramps ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PainLevel.${pain.crampLevel}`} />
                  </td>
                  <td>{pain.ovulationPain ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PainLevel.${pain.opLevel}`} />
                  </td>
                  <td>{pain.headache ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PainLevel.${pain.headacheLevel}`} />
                  </td>
                  <td>{pain.backache ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PainLevel.${pain.backacheLevel}`} />
                  </td>
                  <td>{pain.nausea ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PainLevel.${pain.nauseaLevel}`} />
                  </td>
                  <td>{pain.tenderBreasts ? 'true' : 'false'}</td>
                  <td>{pain.migraine ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PainLevel.${pain.migraneLevel}`} />
                  </td>
                  <td>{pain.other ? 'true' : 'false'}</td>
                  <td>{pain.comments}</td>
                  <td>{pain.active ? 'true' : 'false'}</td>
                  <td>{pain.draft ? 'true' : 'false'}</td>
                  <td>{pain.cursor}</td>
                  <td>{pain.lastUpdated}</td>
                  <td>{pain.microSec}</td>
                  <td>{pain.timestampEntry}</td>
                  <td>{pain.cycleDay ? <Link to={`/cycle-day/${pain.cycleDay.id}`}>{pain.cycleDay.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/pain/${pain.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pain/${pain.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pain/${pain.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pain.home.notFound">No Pains found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={painList && painList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Pain;
